import { Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../css/admin/header.scss";
import { useLogout } from "../../../queries";

const Header = () => {
  let history = useNavigate();
  const logoutMutation = useLogout();

  const logoutHandle = () => {
    logoutMutation.mutate();
    history("/");
  };
  return (
    <div className="header">
      <Button
        onClick={logoutHandle}
        variant="contained"
        className="logoutButton"
        endIcon={<LogoutIcon />}
      >
        logout
      </Button>

      <div>Hello, Admin</div>
    </div>
  );
};

export default Header;
